import styled from 'styled-components'

export const MembersListItemStyled = styled.li`
  align-items: center;
  display: flex;
  min-width: ${(props) => props.theme.typography.pxToRem(155)};
`
